import React, { useState, useEffect, useMemo } from 'react'
import ExamTabs from './components/ExamTabs'
import AvatarBody from './components/AvatarBody'

import Informations from "../../pages/builder/informations/Informations";
import { makeStyles } from '@material-ui/core/styles'
import {Box, Button, Toolbar} from "@material-ui/core";
import {useFormContext} from "react-hook-form";
import { isEmpty } from 'lodash';
import { bodyParts } from './enum/bodyParts';
import { useBreakpoint } from 'use-breakpoint';

const BREAKPOINTS = { responsive: 0, desktop: 982 }

const PhysicalExam = ({id, isPreview, helperText, defaultAnswers = [], formData = {}}) =>{
    const [items, setItems] = useState([]);
    const [tabsOpen, setTabsOpen] = useState(false);
    const {getValues, setValue, unregister} = useFormContext();
    const classes = useStyles()

    const { breakpoint } = useBreakpoint(
        BREAKPOINTS,
        'desktop',
    )

    // Calcular items do preview usando useMemo para evitar re-renders desnecessários
    const previewItems = useMemo(() => {
        if (!isPreview) return []
        
        const physicalExamData = formData[id] || defaultAnswers[id]
        
        if (!physicalExamData || isEmpty(physicalExamData)) return []
        
        const avatarKeys = Object.keys(physicalExamData);
        const itemsToAdd = avatarKeys.map(val => {
            const part = bodyParts.find(bp => bp.id == val)
            if (part) return {
                name: part.label,
                component: <part.component 
                    id={id} 
                    segment={part.id} 
                    segmentName={part.label} 
                    removeItems={() => {}} // Função vazia no preview
                    isPreview={true}
                />
            }
            return null
        }).filter(item => item)
        
        return itemsToAdd
    }, [isPreview, formData, id, defaultAnswers])

    const addItems = (item) => {
        if (isPreview) return // Não adiciona items no preview
        
        if ( items.find(it => it.name == item.name) ) {
            return null;
        } else {
            setItems([item, ...items])
            setTabsOpen(true);
        }
    }
    
    const removeItems = (itemName, tag) => {
        if (isPreview) return // Não remove items no preview
        
        setItems( prevItems => prevItems.filter(item => item.name !== itemName));
        unregister(`${id}.${tag}`);
        if(items.length === 0) setTabsOpen(false);
    }

    // useEffect APENAS para modo de edição
    useEffect(() => {
        if (isPreview) return // Não executa nada no preview
        
        // Prioriza formData (dados acumulados) sobre defaultAnswers
        const physicalExamData = formData[id] || defaultAnswers[id]
        
        if (physicalExamData && !isEmpty(physicalExamData)) {
            setValue(id, physicalExamData)
            const avatarParts = physicalExamData
            if (avatarParts) {
                const avatarKeys = Object.keys(avatarParts);
                const itemsToAdd = avatarKeys.map(val => {
                    const part = bodyParts.find(bp => bp.id == val)
                    if (part) return {
                        name: part.label,
                        component: <part.component id={id} segment={part.id} segmentName={part.label} removeItems={removeItems} />
                    }
                    return null
                })
                setItems(itemsToAdd.filter(item => item)); // Remove items undefined
                if (itemsToAdd.length > 0) {
                    setTabsOpen(true);
                }
            }
        }
    }, [isPreview, id, defaultAnswers, formData]) // isPreview como primeira dependência

    const tabsHandler = {
        isOpen: isPreview ? previewItems.length > 0 : tabsOpen,
        setOpen: isPreview ? () => {} : setTabsOpen // Função vazia no preview
    }

    const portalStyle = {
        position: 'absolute',
        left: '-62px',
        top: '120px'
    }

    // No preview, usar previewItems; no modo normal, usar items
    const currentItems = isPreview ? previewItems : items
    const currentTabsOpen = isPreview ? previewItems.length > 0 : tabsOpen

    const showAvatar = (!currentTabsOpen && breakpoint == 'responsive') || breakpoint == 'desktop'
    const showFields = (currentTabsOpen && breakpoint == 'responsive') || breakpoint == 'desktop'

    return (
        <>
        {!isPreview && <Toolbar style={{fontFamily:'Roboto, sans-serif', fontWeight: '300'}}>Abaixo, descreva o exame realizado:</Toolbar>}
        {isPreview && <Toolbar style={{fontFamily:'Roboto, sans-serif', fontWeight: '300'}}>Exames Fisicos: </Toolbar>}
        <div id="oi" style={{textAlign:"center", position: 'relative'}} className={classes.wrapper}>
            {!isPreview && showAvatar && <AvatarBody id={id} isPreview={isPreview} addItems={addItems} removeItems={removeItems} tabsHandler={tabsHandler}/> }
            {
                !isPreview && <>
                    {
                        showFields ?
                            <ExamTabs items={currentItems} tabsHandler={tabsHandler} isPreview={isPreview} />
                        : <Box style={portalStyle}>
                            {
                                currentItems.length > 0 &&
                                    <Button size='small' color='primary' className="form-button" variant='contained' onClick={() => setTabsOpen(true)}>
                                        Formularios ({ currentItems.length })
                                    </Button>
                            }
                        </Box>
                    }
                </>
            }
            {
                isPreview && showFields && 
                <ExamTabs items={currentItems} tabsHandler={tabsHandler} />
            }
        </div>
        </>
    )
}

const useStyles = makeStyles(() =>({
wrapper:{
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gridGap: '16px'
}
}))

export default PhysicalExam